import { useState, useEffect } from "react";
import { Form, Col, Row, Modal } from "antd";
import useGet from "../../../global/hooks/useGet";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { DollarCircleOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { GlobalTable } from "../../../global/components/GlobalTable";
import MyPaymentForm from "../../../global/components/PaymentForm";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import OrderItemIcon from "../../../assets/images/vectors/SideBarIcons/OrderItemIcon";
import { OrderTable } from "./OrderTable";
import { PaymentOrderColumns } from "../Page/Column";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import dayjs from "dayjs";
import usePost from "../../../global/hooks/usePost";

export const InvoiceInfoForm = ({ type }) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [selectedOemNo, setSelectedOemNo] = useState(loggedInUser?.oem_no);
  const [paymentModal, setPaymentModal] = useState(false);
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  //const { role_value } = userData;
  const role_value = userData?.role_value;
  const [showModal, setShowModal] = useState(false);
  const [listData, setListData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  // const [modalType, setModalType] = useState("");
  // const [isOpenModal, setIsOpenModal] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [params, setParams] = useState({
    limit: 10,
    sort_by: "OrderNo",
    order: "desc",
  });
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
  });
  const [selectedDealerNo, setSelectedDealerNo] = useState();

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  // to get table data from API server

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/dealers/options/`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/invoices/`;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const modifiedOems = getModifiedResponse(optionData, "oems");

  const dealerOptionsUrl =
    selectedOemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          defaultData?.OemNo ? defaultData.OemNo : selectedOemNo
        }/dealers/`
      : null;

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const url = id && `${process.env.REACT_APP_API_URL}/api/invoices/${id}/`;
  const { data, error, refetch } = useGet(url);

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...params,
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        // setShowModal(true);
        setOrderData(record);
      },
    };
  };

  // const handleCreateNew = (type) => {
  //   setModalType(type);
  //   setIsOpenModal(true);
  // };

  useEffect(() => {
    const getAccountInfoById = () => {
      try {
        if (data?.data) {
          form.setFieldsValue({
            OemName: data.data.OemName ? String(data.data.OemName) : "",
            Dealer: data.data.Dealer ? String(data.data.Dealer) : "",
            InvoiceTime: data.data.InvoiceTime
              ? dayjs(data.data.InvoiceTime)
              : null,
            Month: data.data.Month ? dayjs(data.data.Month, "YYYY-MM") : null,
            Amount: data.data.Amount
              ? `$${Number(data.data.Amount).toFixed(2)}`
              : "",
            Dealer_Discount:
              typeof data.data.Dealer_Discount === "number"
                ? `${data.data.Dealer_Discount}%`
                : "",
            Amount_with_discount: data.data.Amount_with_discount
              ? `$${Number(data.data.Amount_with_discount).toFixed(2)}`
              : "",
            TransactionID: data?.data?.TransactionID,
            PaymentStatus: data?.data?.PaymentStatus,
            CardLast4: data?.data?.CardLast4,
            Paid: data?.data?.Paid,
            PaymentTime: data.data.PaymentTime
              ? dayjs(data.data.PaymentTime)
              : null,
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        console.log({ error });
        openErrorNotification("Error fetching data!");
      }
    };

    getAccountInfoById();
  }, [id, data, form]);

  useEffect(() => {
    if (data?.data) {
      const newData = data?.data?.InvoiceItems.map((el) => ({
        ...el,
        key: el?.ItemNo,
      }));
      setListData(newData);
    }
  }, [data?.data]);
  const onReset = () => {
    navigate(`/invoice`);
  };

  const breadcrumbItems = [
    {
      label: "Invoice",
      href: "/invoice",
    },
    {
      label: id ? "Information" : "Create",
      href: `/invoice/info/${id}`,
    },
  ];

  const buttonsData = [
    // {
    //   label: "Email",
    //   icon: <MailOutlined />,
    //   onClick: () => {
    //     // navigate(`/payment/edit/${id}`);
    //     console.log("Email sent!");
    //   },
    // },

    ...(data?.data?.Paid === "No" && [7, 8, 9].includes(role_value)
      ? [
          {
            label: "Payment",
            icon: <DollarCircleOutlined />,
            onClick: () => {
              setPaymentModal(true);
            },
          },
        ]
      : []),
    {
      label: "List",
      icon: <UnorderedListOutlined />,
      onClick: () => {
        navigate(-1);
      },
    },
  ];

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      navigate("/invoice");
    }
  }, [postError, postData, postLoading]);

  // console.log("data", buttonsData);

  return (
    <div>
      <Form
        validateTrigger={"onChange"}
        form={form}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>
          {
            <div className="border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <PaymentIcon className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Invoice
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomDateTimePicker
                      name="InvoiceTime"
                      label="Invoice Time"
                      placeholder="Invoice Time"
                      format="YYYY-MM-DD HH:mm" // 24-hour format
                      disabled
                    />
                  </Col>

                  {![4, 5, 6, 7, 8, 9].includes(loggedInUser.role_value) && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput label="Dealer" name="Dealer" disabled />
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomDateTimePicker
                      name="Month"
                      placeholder="Month"
                      label="Month"
                      picker={"month"}
                      disabled
                    />
                  </Col>
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Invoice Time"
                        name="InvoiceTime"
                        disabled={type === "info"}
                      />
                    </Col> */}

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput label="Amount" name="Amount" disabled={true} />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Dealer Discount"
                      name="Dealer_Discount"
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Discounted Amount"
                      name="Amount_with_discount"
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput label="Paid" name="Paid" disabled={true} />
                  </Col>
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Transaction ID"
                        name="TransactionID"
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Payment Status"
                        name="PaymentStatus"
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Last 4 digits of Card"
                        name="CardLast4"
                        disabled={true}
                      />
                    </Col> */}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomDateTimePicker
                      name="PaymentTime"
                      label="Payment Time"
                      placeholder="Payment Time"
                      format="YYYY-MM-DD HH:mm" // 24-hour format
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>

      <div className="mt-6">
        <GlobalTable
          columns={PaymentOrderColumns(setParams, params)}
          dataSource={listData}
          pagination={paginationConfig}
          onRow={onRow}
          // resize
        />
      </div>
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-[9px] rounded-md">
            <OrderItemIcon className="text-[18px] text-black " />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Ordered Items
            </span>
          </div>
        }
        closable={true}
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        closeIcon={<span className=" -mt-[26px]  transition">✖</span>}
        width={900}
        centered
      >
        <OrderTable paymnetId={id} orderData={orderData} />
      </Modal>
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-2.5 rounded-md">
            <PaymentIcon className="text-[18px] text-black " />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Make Payment
            </span>
          </div>
        }
        open={paymentModal}
        onCancel={() => setPaymentModal(false)}
        footer={null}
        closeIcon={<span className=" -mt-[22px]  transition">✖</span>}
        width={560}
        centered
        destroyOnClose
      >
        <div>
          <MyPaymentForm
            DealerNo={data?.data?.DealerNo}
            amount={data?.data?.Amount}
            setPaymentModal={setPaymentModal}
            InvoiceNo={id}
            OrderName={data?.data?.OrderName}
            refetch={refetch}
          />
        </div>
      </Modal>
    </div>
  );
};
